module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray-9cc07486764ab58714f7e3db30db76e3.png";